<template>
  <div
    class="Others1Charts"
    @mousedown="!isEditMode && isOpenLink && echartClick($event)"
    :class="{ link: isOpenLink && !isEditMode ? true : false }"
  >
    <div class="echarts" :id="Configuration.id"></div>
    <div class="no-data" v-if="noData">
      <sapn>暂无数据！</sapn>
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import { mapState } from 'vuex';
import { jumpSomePlaceByLink, getFilterValue } from '../../../../utils/tool';
import { request } from '../../../../common/request';
export default {
  name: 'Others1Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      noData: false,
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,

      // params: {}, // 请求参数
      // paramsCopy: {},
    };
  },
  computed: {
    ...mapState({ isEditMode: state => state.isEditMode }),
    isOpenLink() {
      return this.Configuration.propertyData?.chartLink?.value?.isOpenLink;
    },
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });

    // this.getApiDataResByFilterAndResponseQuery();
    // 默认取api参数
    // let that = this;
    // let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    // let params = ChartsData?.apiData?.apiPostParams || '{}';
    // // console.log('aaaa',params);
    // this.params = eval('(' + params + ')');
    // this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    getFilterValue(e) {
      return getFilterValue(e);
    },
    echartClick(e) {
      e.stopPropagation();
      console.log('点击');
      let type = this.Configuration.propertyData.chartLink.value.linkType;
      let url = this.Configuration.propertyData.chartLink.value.linkUrl;
      jumpSomePlaceByLink(type, url);
      console.log('执行后');
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      if (Object.keys(ParamData).length == 0 || ParamData.source.length == 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      console.log(source);
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle, '35425245345');
      console.log(grid);

      let xData = [];
      let yData = [];
      let xyData = [];
      let unit = '';

      function DealData() {
        seriesList.forEach(s => {
          source.forEach((item, index) => {
            if (s === item.s) {
              unit = item.s;
              if (index >= 5) return;
              xData.push(item.x);
              yData.push(item.y);
              xyData.push({
                name: item.x,
                value: parseInt(item.y),
              });
            }
          });
        });
      }
      DealData();

      const colors = [
        'rgba(255,158,255,1)',
        'rgba(125,179,133,1)',
        'rgba(240,189,108,1)',
        'rgba(159,130,246,1)',
        'rgba(122,193,168,1)',
        'rgb(123,39,229,1)',
        'rgba(180,80,54,1)',
        'rgba(237,274,102,1)',
        'rgba(219,119,160,1)',
        'rgba(229,115,53,1)',
        'rgba(140,9,44,1)',
        'rgba(237,215,102,1)',
        'rgba(208,119,219,1)',
        'rgba(179,4,88,1)',
        'rgba(240,189,178,1)',
        'rgba(217,219,67,1)',
        'rgba(223,68,56,1)',
        'rgba(229,115,53,1)',
        'rgba(136,109,137,1)',
        'rgba(237,215,102,1)',
      ];

      // console.log(colors[0].slice(0, 7).concat('', '1,193,12,0.8)'), '222222')

      const dataValue = yData;
      const axisLabelData = xData;
      // 内层刻度和指针
      const baseInner = {
        radius: '100%',
        type: 'gauge',
        splitNumber: 6, //刻度数量
        splitLine: {
          length: -8,
          lineStyle: {
            color: 'auto',
            with: 6,
          },
        },
        axisTick: {
          lineStyle: {
            width: 1,
            color: 'auto',
          },
          splitNumber: 6,
          length: -5,
        },
        detail: {
          show: false,
        },
        pointer: {
          show: false,
        },
        axisLabel: {
          show: false,
          color: 'aqua',
          distance: 60,
        }, //刻度标签。
      };
      let Options = [];
      var sCenter;
      var that = this;
      dataValue.forEach(function (item, index) {
        sCenter = [index * 20 + 10 + '%', '40%'];
        Options.push({
          ...baseInner,
          axisLine: {
            show: false,
            lineStyle: {
              color: [
                [
                  1,
                  new Echarts.graphic.LinearGradient(3, 3, 4, 0, [
                    { offset: 0, color: colors[index] },
                    { offset: 0.4, color: colors[index].slice(0, 7).concat('', '9,193,12,1)') },
                    { offset: 0.6, color: colors[index].slice(0, 7).concat('', '8,289,108,1)') },
                    { offset: 1, color: colors[index].slice(0, 7).concat('', '7,319,219,1)') },
                  ]),
                ],
              ],
              // color: gradientColors,
            },
          },
          center: sCenter,
          detail: {
            formatter: '{value}',
            offsetCenter: ['0', '0'],
            fontSize: that.$h_Ratio(fontStyle.yAxisSize, that.$store),
            fontWeight: 1000,
            color: fontStyle.yAxisColor,
          },
          title: {
            offsetCenter: ['0', '90%'],
            fontWeight: 800,
            fontSize: that.$h_Ratio(fontStyle.xAxisSize, that.$store),
            color: fontStyle.xAxisColor,
          },
          data: [
            {
              value: item,
              name: axisLabelData[index],
            },
          ],
        });
      });

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        series: Options,
      };
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setTimeout(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let params = ChartsData.apiData.apiPostParams || '{}';
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || '{}';
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            data: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        // mychart.clear();
        llmychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '多项仪表盘',
    componentName: 'Gauge2Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others1Charts.png',
    id: '',
    style: {
      width: 500,
      height: 130,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果        
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
            isUseUserKey: false, // 是否使用user_key
          },
          staticData: {
            seriesList: ['人数'],
            source: [
              {
                s: '人数',
                y: '122',
                x: '1-15',
              },
              {
                s: '人数',
                y: '67',
                x: '16-20',
              },
              {
                s: '人数',
                y: '55',
                x: '21-30',
              },
            ],
          },
        },
      },
      // 链接
      chartLink: {
        propertyComponentName: 'ChartsLinkConfiger',
        value: {
          isOpenLink: false, // 是否开启链接
          linkType: 'inner', // 链接类型 inner内链场景、outer外链地址
          linkUrl: '', // 链接url ，inner时是场景的id、outer时是http地址
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others1Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
  .no-data {
    width: 100%;
    height: 100%;
    // background: #000;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #a9a9a9;
  }
}

.link {
  // cursor:pointer;
  :deep()canvas {
    &:hover {
      // pointer-events: auto;
      cursor: pointer;
    }
  }
}
</style>
